import React, { useEffect, useState } from "react";
import { DateFormate } from "../../../lib/utils";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../../lib/api";
import { toast } from "sonner";
import { DataTable } from "src/components/DataTable";
import MainButton from "../../../components/MainButton";
import { ArrowUpDown, Edit2, PlusCircle, Trash2 } from "lucide-react";
import { Spin, Tooltip } from "antd";
import { Button } from "../../../components/ui/button";
import DialogDelete from "../../../components/common/DialogDelete";
import { useLanguage } from "../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { DrawerSurveyShowAnswer } from "./_components/DrawerSurveyShowAnswer";

export default function SurveysPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [surveys, setSurveys] = useState([]);
  const [loadingSurveys, setLoadingSurveys] = useState(true);
  const getAllSurveys = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/surveys`);
      setSurveys(data.data);
    } catch (error) {
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingSurveys(false);
    }
  };

  useEffect(() => {
    getAllSurveys();
  }, []);

  const columns = [
    {
      accessorKey: "title",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Title
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ getValue }) => (
        <div
          className="prose max-w-none"
          dangerouslySetInnerHTML={{ __html: getValue() }}
        />
      ),
    },
    {
      accessorKey: "created_at",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Created At
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ getValue }) => DateFormate(getValue()),
    },
    {
      accessorKey: "Actions",
      cell: ({ row }) => {
        const data = row.original;

        return (
          <div className="flex items-center gap-1">
            <Tooltip title="Show Questions">
              <DrawerSurveyShowAnswer surveyData={data} />
            </Tooltip>

            <Button
              variant="ghost"
              size="icon"
              onClick={() =>
                navigate(`/admin/edit-survey`, { state: { survey: data } })
              }
            >
              <Edit2 />
            </Button>
            <DialogDelete
              apiLink={`/surveys/${data?.id}`}
              onSuccess={getAllSurveys}
              itemTitle={data.title}
              name={"Survey"}
            >
              <Button variant="ghost" size="icon">
                <Trash2 />
              </Button>
            </DialogDelete>
          </div>
        );
      },
    },
  ];

  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="flex items-center gap-2 justify-between flex-wrap">
        <h1 className="text-2xl font-bold">Surveys</h1>
        <MainButton
          Icon={PlusCircle}
          title={"Add Survey"}
          onClick={() => navigate(`/admin/add-survey`)}
        />
      </div>

      {loadingSurveys ? (
        <div className="flex items-center justify-center h-40">
          <Spin size="large" />
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={surveys}
          title={"Surveys by title"}
          filterNames={["title"]}
        />
      )}
    </div>
  );
}
